/* eslint-disable no-restricted-syntax */
import { grey } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#0041D2",
      dark: "#002E95",
      light: "#5480E1",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#616161",
      light: "#9E9E9E",
      dark: "#424242",
      contrastText: "#FFFFFF",
    },
    grey: {
      50: "#FAFAFA",
      100: "#F5F5F5",
      200: "#EEEEEE",
      300: "#E0E0E0",
      400: "#BDBDBD",
      500: "#9E9E9E",
      600: "#757575",
      700: "#616161",
      800: "#424242",
      900: "#212121",
    },
    text: {
      primary: "#212121",
      secondary: "#616161",
      disabled: "#BDBDBD",
      placeholder: "#BDBDBD",
    },
    error: {
      main: "#CB2A26", // should be #DF2E2A to match the design ff_emarketing_integration
      light: "#E55855",
      dark: "#7B1917",
      contrastText: "#FFFFFF",
    },
    info: {
      main: "#00D2FC",
      light: "#54E1FD",
      dark: "#0095B3",
      contrastText: "#003944",
    },
    success: {
      main: "#4BA063",
      light: "#86BF96",
      dark: "#295836",
      contrastText: "#FFFFFF",
    },
    warning: {
      main: "#FFA800",
      light: "#FFC554",
      dark: "#B57700",
      contrastText: "#3B2700",
    },
    orange: {
      main: "#E36D09",
    },
    divider: "#E0E0E0",
    background: {
      paper: "#FFFFFF",
      dark: "#03193F",
      lightBlue: "#F3F7FE",
      coolBlue: "#B0C4F1", // Cool Blue
      error: "#FCEAEA",
      warning: "#FFF6E6",
      success: "#EDF6EF",
      info: "#E6FBFF",
    },
    state: {
      active: "#E0E0E0", // active item element
      hover: "#F5F5F5", // hover item element
    },
    border: {
      divider: "#E0E0E0",
      default: "#E0E0E0",
      brand: "#0141d2",
    },
    common: {
      white: "#FFFFFF",
      black: "#000000",
      navy: "#001F3F",
    },
    action: {
      active: "#757575",
      hover: "#F5F5F5",
      selected: "#EBEBEB",
      disabled: "#9E9E9E",
      focus: "#E0E0E0",
    },
    accent: {
      pink: {
        lightest: "#FCEBF2",
        light: "#F7BFD5",
        main: "#E53279",
        dark: "#A32456",
        darkest: "#601533",
      },
      purple: {
        lightest: "#F7E9F6",
        light: "#E6BAE2",
        main: "#AF1FA2",
        dark: "#7C1673",
        darkest: "#4A0D44",
      },
      darkOrange: {
        lightest: "#FDEFEC",
        light: "#F8CCC3",
        main: "#E95B3C",
        dark: "#A5412B",
        darkest: "#622619",
      },
      teal: {
        lightest: "#ECF5F6",
        light: "#C5DFE2",
        main: "#4598A1",
        dark: "#316C72",
        darkest: "#1D4044",
      },
      lightGreen: {
        lightest: "#E6F6F2",
        light: "#B0E4D6",
        main: "#00A87C",
        dark: "#007758",
        darkest: "#004734",
      },
      shadeBlue: {
        lightest: "#E6F3F9",
        light: "#B0DBED",
        main: "#008BC5",
        dark: "#00638C",
        darkest: "#003A53",
      },
      darkGrey: {
        lightest: "#EDECEE",
        light: "#C6C5CA",
        main: "#474554",
        dark: "#32313C",
        darkest: "#1E1D23",
      },
      yellow: {
        lightest: "#FFFBE6",
        light: "#FFF2B0",
        main: "#FFD500",
        dark: "#B59700",
        darkest: "#6B5900",
      },
      other: {
        default: "#EEEEEE",
        lightBlue: "#B0C4F1",
        lightGreen: "#C7E2CF",
        lightOrange: "#FFE4B0",
        lightAqua: "#B0F1FE",
      },
    },
  },
  typography: {
    button: {
      fontWeight: "bold",
    },
    fontFamily: "Lato",
    h6: {
      fontSize: "1.15rem",
      fontWeight: "bold",
    },
    h5: {
      fontWeight: "bold",
    },
    subtitle1: {
      fontWeight: "bold",
    },
    subtitle2: {
      fontWeight: "bold",
    },
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: "bold",
        },
        root: {
          borderBottomColor: grey[200],
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        img: {
          objectFit: "contain",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        sizeSmall: {
          fontSize: 13,
        },
        sizeMedium: {
          fontSize: 14,
        },
        sizeLarge: {
          fontSize: 15,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .Mui-disabled": {
            backgroundColor: grey[100],
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          "& .Mui-disabled": {
            backgroundColor: grey[100],
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          "&.MuiListItemIcon-root": { minWidth: 0 },
          marginRight: 8,
        },
      },
    },
  },
});
